import { useEffect, useState } from "react";

import { staffImageData } from "../../assest/imgPaths";

const CompanyTeamSection = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

 
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); 
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1500);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="relative min-h-[60vh] xl:min-h-screen text-center bg-inherit flex items-center justify-center ">
      <div className="relative w-full h-full bg-inherit ">
        <div className="absolute flex flex-col items-center justify-center xl:justify-end pb-20 text-primary-orange inset-0 h-full w-full z-10 ">
          <h2 className="text-2xl md:text-4xl xl:text-8xl font-gilroy tracking-wider xl:mb-4">
            K2 გუნდი
          </h2>

          <p className="my-4 px-6 md:p-0 max-w-2xl text-sm md:text-xl tracking-wider font-semibold">
            მოკლედ გუნდის შესახებ
          </p>
        </div>
        <div className="w-full inset-0 overflow-hidden bg-black h-[50vh] xl:h-[90vh] flex items-center justify-center ">
          <img
            // src={image3}
            src={staffImageData.staff}
            alt="Promo Background"
            className={` opacity-60 inline-block max-w-full w-full h-[50vh] xl:h-[120vh] text-center align-middle object-cover`}
            style={{
              transform: `translateY(-${
                isLargeScreen ? scrollY * 0.03 : scrollY * 0.00
              }px)`,
              transition: "transform 1s",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default CompanyTeamSection;
